import { useMutation } from '@tanstack/react-query';
import { message } from 'antd';
import { I18n } from '@aws-amplify/core';
import { DataExtractionService } from '@/infra/services/data-extraction';

interface CreateDataExtractionByModelParams {
	organization_id: string;
	company_id: string;
	extraction_name: string;
	data_extraction_model_id: string;
	sector_id?: string;
	line_id?: string;
	workstation_id?: string;
	start_date?: string;
	end_date?: string;
}

const Service = DataExtractionService.getInstance();

export const useCreateDataExtractionByModel = () => {
	return useMutation({
		mutationFn: async (params: CreateDataExtractionByModelParams) => Service.createByModel(params),
		onSuccess: () => {
			message.success(I18n.get('Data extraction created successfully'));
		},
		onError: () => {
			message.error(I18n.get('Error creating data extraction'));
		}
	});
};
